import { useEffect, useState } from "react";
import api from "@/components/customAxios/Axios";
import { Link } from "react-router-dom";
import Pagination from "../Pagination";
// import { FiSearch } from "react-icons/fi";
type UserUsage = {
	assessment_usage: {
		count: number;
		percentage: number;
	};
	cv_usage: {
		count: number;
		percentage: number;
	};
	email: string;
	name: string;
	overall_utilization_percentage: number;
	role: string;
	user_id: string;
	users_added: {
		count: number;
		percentage: number;
	};
};
const ResourceUtilization = () => {
	const [data, setData] = useState<UserUsage[]>([]);
	const [currentPage, setCurrentPage] = useState(1);
	const [totalPages, setTotalPages] = useState(0);
	// const [itemsPerPage, setItemsPerPage] = useState(10);
	const [totalItems, setTotalItems] = useState(0);
	const getApplicants = async () => {
		try {
			const response = await api.get("/api/admin/user-resource-utilization");
			if (response.status === 200) {
				setData(response.data.users);
				setTotalItems(response.data.total);
				setTotalPages(Math.ceil(response.data.pages));
			}
		} catch (error) { }
	};
	useEffect(() => {
		getApplicants();
	}, [currentPage]);
	const handlePageClick = (page: number) => {
		setCurrentPage(page);
	};
	return (
		<div className=" mt-3 bg-white rounded-lg p-3 ">
			<div className="flex justify-between gap-x-1 items-center  font-body">
				<h2 className="mr-5 font-bold text-lg">User Resource Utilization</h2>
				<Link to="/settings" className="text-gray-500 hover:underline">
					View All
				</Link>
			</div>
			{/* user log table */}
			<div className=" overflow-x-auto mt-3">
				<div className="max-h-[450px] min-h-[450px] overflow-y-auto p-2 w-full">
					<div className="space-y-6">
						{data.map((user) => (
							<div
								key={user.user_id}
								className="flex items-center gap-4 w-full"
							>
								{/* Avatar */}
								<div className="size-16 rounded-full bg-gray-100 flex items-center justify-center text- font-medium text-gray-700">
									{user.name === "None None"
										? "NA"
										: user.name
											.split(" ")
											.map((n) => n[0])
											.join("")
											.toUpperCase()}
								</div>

								{/* User Info */}
								<div className="flex-1">
									<div className="text-sm font-semibold text-gray-900">
										{user.name === "None None" ? "N/A" : user.name}
									</div>
									<div className="text-sm mt-1.5">
										<div className="flex items-center gap-1">
											<div className="size-2 rounded-full bg-blue-500"></div>
											<span>
												Resources Utilized:{" "}
												{user.overall_utilization_percentage}%
											</span>
										</div>
									</div>
									<div className="mt-3">
										<div className="w-full bg-gray-200 h-1.5 rounded-full">
											<div
												className="bg-[#434343] h-1.5 rounded-full"
												style={{
													width: `${user.overall_utilization_percentage}%`,
												}}
											/>
										</div>
									</div>
								</div>
							</div>
						))}
					</div>

					{/* <table className="w-full  text-sm ">
                        <thead className="bg-white p-2 font-subheading sticky top-0 text-gray-500">
                            <tr>
                                <th className="p-3 text-left ">Name</th>
                                <th className="p-3 text-left ">Role</th>
                                {/* <th>fs</th> */}
					{/* </tr>
                        </thead>
                        {applicants.length > 0 ? (
                            <>
                                <tbody className="font-body">
                                    {applicants.map((user: any) => (
                                        <tr
                                            key={user.candidate_id}
                                            className="border-b border-gray-300 hover:bg-slate-100"
                                        >
                                            {/* User Column */}
					{/* <td className="p-3 font-medium text-[#438437]"> */}
					{/* {user.name} */}
					{/* {user.email} */}
					{/* <UserLogsModal
                                            userName={user.user_name}
                                            userEmail={user.user_email}
                                        ></UserLogsModal> */}
					{/* </td> */}
					{/* Other Columns */}
					{/* <td className="p-3 text-gray-700">{user.jds_created}</td> */}
					{/* <td className="p-3 text-gray-700">{user.job_name}</td>
                                            <td className="p-3 text-gray-700"> */}
					{/* <CandidateDetailsModal
                                                    candidateId={user.candidate_id}
                                                    candidateName={user.name}
                                                ></CandidateDetailsModal> */}
					{/* </td>
                                        </tr>
                                    ))}
                                </tbody> */}

					{/* <tfoot className="sticky bottom-0 bg-gray-100  font-subheading ">
                                        <Pagination
                                            dataLength={userLogs.length}
                                            currentPage={currentPage}
                                            handlePageClick={handlePageClick}
                                            totalItems={totalItems}
                                            totalPages={totalPages}
                                        />
                                    </tfoot> */}
					{/* </>
                        ) : (
                            <tbody>
                                <tr>
                                    <td
                                        colSpan={6}
                                        className="p-3 text-center font-semibold text-2xl text-gray-500"
                                    >
                                        No Data Found
                                    </td>
                                </tr>
                            </tbody>
                        )} */}
					{/* </table>  */}
				</div>
			</div>
			<Pagination
				dataLength={data.length}
				currentPage={currentPage}
				handlePageClick={handlePageClick}
				totalItems={totalItems}
				totalPages={totalPages}
			/>
		</div>
	);
};

export default ResourceUtilization;